<!-- TEMPLATE -->
<template>
  <div class='profile-contact-details'>
    <dean-two-column-layout :title="headerTitle">
      <dean-section-title-remove-restore
              v-if="$route.name === 'profile.contact.edit'"
              slot="title-items"
              :is-removed="isDeleted"
              text-remove="Verwijderen" :remove-icon="trashIcon" @remove="deleteContact"
              text-restore="Herstellen" :restore-icon="lockOpenIcon" @restore="restoreContact"
      >
      </dean-section-title-remove-restore>
      <dean-section-title-item
              v-if="!isDeleted"
              :icon='saveIcon'
              slot="title-items"
              :content="true"
              :large="true"
              @click.native="processContact"
      >
        Opslaan
      </dean-section-title-item>
      <div class="column" slot="left">
        <dean-form-row id="givenName" v-model="contactData.personalName.givenName" label="Voornaam" @input="inputFieldChanged"
                       :disabled="isDeleted"
                       :required-field="true" :warning="$v.data.personalName.givenName.$error"
                       @focus="$v.data.personalName.givenName.$touch()"></dean-form-row>
        <dean-form-row id="surnamePrefix" v-model="contactData.personalName.surnamePrefix" label="Tussenvoegsels"
                       :disabled="isDeleted"
                       @input="inputFieldChanged"></dean-form-row>
        <dean-form-row id="surname" v-model="contactData.personalName.surname" label="Achternaam" @input="inputFieldChanged"
                       :disabled="isDeleted"
                       :required-field="true" :warning="$v.data.personalName.surname.$error"
                       @focus="$v.data.personalName.surname.$touch()"></dean-form-row>
        <dean-form-row id="jobTitle" v-model="contactData.personalName.jobTitle" label="Functietitel"
                       :disabled="isDeleted"
                       @input="inputFieldChanged"></dean-form-row>
        <dean-form-row id="phoneNumber" v-model="contactData.phoneNumber" label="Telefoonnummer"
                       :disabled="isDeleted"
                       @input="inputFieldChanged"></dean-form-row>
        <dean-form-row id="emailAddress" v-model="contactData.emailAddress" label="E-mailadres"
                       @input="inputFieldChanged"
                       :disabled="disableEmailAddressField || isDeleted"
                       :required-field="true" :warning="$v.data.emailAddress.$error"
                       @focus="$v.data.emailAddress.$touch()"></dean-form-row>
      </div>
      <div class="column" slot="right">
        <dean-input-switch-form-row id="receivesInvoices" :value="contactData.receivesInvoices"
                                    @checked="inputSwitchChanged"
                                    :disabled="isDeleted"
                                    label="Ontvangt facturen"></dean-input-switch-form-row>
        <dean-input-switch-form-row id="receivesNotifications" :value="contactData.receivesNotifications"
                                    @checked="inputSwitchChanged"
                                    :disabled="isDeleted"
                                    label="Ontvangt berichten"></dean-input-switch-form-row>
      </div>
    </dean-two-column-layout>
  </div>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {Component, Vue, Watch} from 'vue-property-decorator';
  import vSelect from 'vue-select';
  import axios from 'axios';
  import {deanDialogBus} from '@/main';
  import {validationMixin} from 'vuelidate';
  import {required, email} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification, validationMessage} from '@/mixins/validations';
  import {CollapseTransition} from 'vue2-transitions';

  import {
    customerIcon,
    businessIcon,
    commissionIcon,
    partnerIcon,
    deanAlertDialog,
    deanIcon,
    deanInputField,
    deanSearchField,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    invoicesIcon,
    messageIcon,
    offersIcon,
    ordersIcon,
    returnIcon,
    saveIcon,
    summeryIcon,
    usersIcon,
    lockOpenIcon,
    trashIcon,
    warningIcon,
  } from '@deanone/dean-components';
  import DeanTwoColumnLayout from '@/components/deanComponents/deanTwoColumnLayout.vue';
  import deanInputSelect from '@/components/deanComponents/deanInputSelect.vue';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import DeanInputSwitchFormRow from '@/components/deanComponents/deanInputSwitchFormRow.vue';
  import DeanMultiSelectFormRow from '@/components/deanComponents/deanMultiSelectFormRow.vue';
  import deanSectionTitleRemoveRestore from '@/components/deanComponents/deanSectionTitleRemoveRestore.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import sideMenuProfileMixin from '@/mixins/sideMenuProfileMixin';
  import {mixins} from 'vue-class-component';

  @Component({
    components: {
      deanSectionTitleRemoveRestore,
      DeanMultiSelectFormRow,
      DeanInputSwitchFormRow,
      DeanSelectFormRow,
      deanAlertDialog,
      deanInputField,
      DeanTwoColumnLayout,
      deanInputSelect,
      deanFormRow,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      vSelect,
      invoicesIcon,
      deanIcon,
      returnIcon,
      saveIcon,
      summeryIcon,
      partnerIcon,
      businessIcon,
      usersIcon,
      offersIcon,
      ordersIcon,
      commissionIcon,
      messageIcon,
      CollapseTransition,
    },
    mixins: [validationMixin],
  })

  export default class Details extends mixins(sideMenuProfileMixin) {
    public params: any = {};
    public saveIcon: object = saveIcon;
    public lockOpenIcon: object = lockOpenIcon;
    public trashIcon: object = trashIcon;
    public roleOptions: object[] = [];
    public data: {
      personalName: {
        givenName: any,
        surnamePrefix: any,
        surname: any,
        jobTitle: any,
      },
      id: any,
      organizationId: any,
      isUser: boolean,
      phoneNumber: any,
      emailAddress: any,
      receivesInvoices: any,
      receivesNotifications: any,
    } = {
      personalName: {
        givenName: null,
        surnamePrefix: null,
        surname: null,
        jobTitle: null,
      },
      id: null,
      organizationId: null,
      isUser: false,
      phoneNumber: null,
      emailAddress: null,
      receivesInvoices: false,
      receivesNotifications: false,
    };
    public isDeleted: boolean = false;
    public userEmailAddress: string = '';

    // COMPUTED
    @Validations()
    get validations() {
      const valData: any = {
        data: {
          personalName: {
            surname: {required},
            givenName: {required},
          },
          emailAddress: {required, email},
        },
      };

      return valData;
    }

    get contactData() {
      return this.data;
    }

    get headerTitle(): string {
      return (this.$route.params.id !== undefined) ? 'Contact wijzigen' : 'Contact toevoegen';
    }

    get user() {
      return this.$store.getters.getUser;
    }

    get disableEmailAddressField() {
      return false;
    }

    public inputSwitchChanged(field: { id: any, value: any }) {
      const key: string = field.id;
      // @ts-ignore-next-line
      this.data[key] = field.value;
    }

    public inputFieldChanged(field: any) {
      const name: string = field.id;
      // @ts-ignore-next-line
      this.data[name] = field.value;
    }

    public contactDetails() {
      this.params = {
        contactId: this.$route.params.id,
        organizationId: this.user.organizationId,
      };

      axios.post('/-/trade/api/person.contact.info', this.params)
        .then(
          (contactResponse: any) => {
            const contactData = contactResponse.data;

            this.data = {
              ...this.data, ...{
                personalName: {
                  givenName: contactData.personalName ? contactData.personalName.givenName : null,
                  surnamePrefix: contactData.personalName ? contactData.personalName.surnamePrefix : null,
                  surname: contactData.personalName ? contactData.personalName.surname : null,
                  jobTitle: contactData.personalName ? contactData.personalName.jobTitle : null,
                },
                phoneNumber: contactData.phoneNumber,
                emailAddress: contactData.emailAddress,
                receivesInvoices: contactData.receivesInvoices,
                receivesNotifications: contactData.receivesNotifications,
              },
            };

            this.userEmailAddress = contactData.userEmailAddress;
            this.isDeleted = contactData.deleted;
          },
          (error: any) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
          },
        );
    }

    public created() {
      if (this.$route.params.id) {
        this.contactDetails();
      }
      this.buildSideMenuProfile();
    }

    public deleteContact() {
      deanDialogBus.$emit('open', 'DeleteContactDialog', {
        id: this.$route.params.id,
        context: 'profile',
        contextId: this.$store.getters.getUser.organizationId,
        givenName: this.data.personalName.givenName,
        surnamePrefix: this.data.personalName.surnamePrefix,
        surname: this.data.personalName.surname,
      });
    }

    public restoreContact() {
      deanDialogBus.$emit('open', 'DeleteContactDialog', {
        id: this.$route.params.id,
        context: 'profile',
        contextId: this.$store.getters.getUser.organizationId,
        givenName: this.data.personalName.givenName,
        surnamePrefix: this.data.personalName.surnamePrefix,
        surname: this.data.personalName.surname,
        state: 'restoring',
      });
    }

    public processContact() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$store.dispatch('setLoadOverlay', true);

        const sendData = this.data;
        if (this.$route.params.id) {
          sendData.id = this.$route.params.id;
        }
        sendData.organizationId = this.$store.getters.getUser.organizationId;
        sendData.isUser = false;

        axios.post('/-/trade/api/person.contact.save', sendData).then(
          (response) => {
            this.$toast({
              icon: saveIcon,
              text: 'Contact opgeslagen',
              theme: 'success',
            });
          },
          (error) => {
            if (error.response.data.errors) {
              let errorText = 'Fout';

              switch (error.response.data.errors[0].code) {
                case 'ERR_EMAIL_NOT_UPDATEABLE':
                  errorText = 'Kan het e-mailadres van een contactpersoon die een gebruiker is, niet bijwerken.';
                  break;
                case 'ERR_EMAIL_NOT_AVAILABLE':
                  errorText = 'E-mailadres is niet beschikbaar.';
                  break;
              }

              this.$toast(validationMessage(errorText));
            } else {
              this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
            }
          },
        ).finally(() => {
          this.$store.dispatch('setLoadOverlay', false);
        });
      } else if (
          false === this.$v.data?.personalName?.$invalid
          && false === this.$v.data?.emailAddress?.$invalid
      ) {
        this.$toast(validationMessage(
            'Het veld Rollen is verplicht wanneer de contactpersoon een gebruiker is.',
        ));
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public mounted() {
      deanDialogBus.$on('contactStatusChange', () => {
        this.contactDetails();
      });
    }

    public destroyed() {
      deanDialogBus.$off('contactStatusChange');
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>